import { FeedbackAdapter } from './feedback.adapter';

export class FeedbackService extends FeedbackAdapter {}
